<template>
  <div class="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid" id="kt_aside_menu_wrapper" style="padding-top: 0px;">
    <div
      id="kt_aside_menu"
      class="kt-aside-menu"
      data-ktmenu-vertical="1"
      data-ktmenu-scroll="1"
      data-ktmenu-dropdown-timeout="500"
      style="margin: 0px;"
    >
      <ul class="kt-menu__nav" style="padding-top: 0px;">
         <li
          class="kt-menu__item"
          :class="{ 'kt-menu__item--active': $route.name == 'home' }"
          aria-haspopup="true"
        >
          <a href="/" class="kt-menu__link">
            <span class="kt-menu__link-icon">
              <i class="fa fa-home"></i>
            </span>
            <span class="kt-menu__link-text">หน้าแรก</span>
          </a>
        </li>
       
        <li
          class="kt-menu__item kt-menu__item--submenu"
          aria-haspopup="true"
          data-ktmenu-submenu-toggle="hover"
          v-for="(val,index) in menu"
          :key="index"
           :class="{ 'kt-menu__item--active': $route.name == val.menu_link }"
        >
          <a 
          href="javascript:void(0)" class="kt-menu__link"  
          v-if="val.sub_menu.length == 0" 
          @click="$router.push({ name: val.menu_link })"
          >
            <span class="kt-menu__link-icon">
              <i v-bind:class="[val.group_menu_icon]"></i>
            </span>
            <span class="kt-menu__link-text"  >{{val.group_manu_name}}</span>
            <i class="la kt-menu__ver-arrow" :class="{ 'la-angle-right': val.sub_menu.length > 0 }"></i>
          </a>
          
          <a 
          href="javascript:void(0)" class="kt-menu__link kt-menu__toggle"
          v-if="val.sub_menu.length > 0" 
          >
            <span class="kt-menu__link-icon">
              <i v-bind:class="[val.group_menu_icon]"></i>
            </span>
            <span class="kt-menu__link-text"  >{{val.group_manu_name}}</span>
            <i class="  la kt-menu__ver-arrow la-angle-right" :class="{ 'la-angle-right': val.sub_menu.length > 0 }"></i>
          </a>
          <div class="kt-menu__submenu" v-if="val.sub_menu.length > 0">
            <span class="kt-menu__arrow"></span>
            <ul class="kt-menu__subnav">
              <li
                class="kt-menu__item" 
                aria-haspopup="true"
                v-for="(vals, index)  in val.sub_menu"
                :key="index"
                :class="{ 'kt-menu__item--active': vals.menu_link == $route.name }"
              >
                <a
                  href="javascript:void(0)"
                  class="kt-menu__link"
                  @click="$router.push({ name: vals.menu_link })"
                  v-show="vals.menu_show == 1"
                >
                  <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
                    <span></span>
                  </i>
                  <span class="kt-menu__link-text">{{ vals.menu_name }}</span>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import api from '../../service/service.js'
export default {
  data () {
    return {
      menu: []
    }
  },
  watch: {},
  computed: {},
  created () {},
  destroyed () {},
  methods: {
    getmenu () {
      // this.menu = this.$store.state.user.menus
      // this.menu = localStorage.Menus
    }
  },
  mounted () {
    if (api.LoggedIn()) {
      this.menu = JSON.parse(sessionStorage.Data).menus
      console.log(this.menu)
    }
    //  console.log(this.menu)
  }
}
</script>


// WEBPACK FOOTER //
// src/components/layout/navbar_menu.vue